import React, { useContext, useState } from "react";
import { Button, Col, Form, FormControl, Row } from "react-bootstrap";
import ContextComponent from "../../Context";
import Modal from "../Modal";

const CommentForm = props => {
  const context = useContext(ContextComponent);
  const [comment_body, set_comment_body] = useState("");
  const [comment_name, set_comment_name] = useState(
    context.profile
      ? context.profile.first_name + " " + context.profile.last_name
      : "",
  );
  const [comment_email, set_comment_email] = useState("");
  const [requesting, set_requesting] = useState(false);

  const sendComment = () => {
    set_requesting(true);
    context.ApiDriver.postComment(
      {
        body: comment_body,
        post_id: props.post_id,
        fullname: comment_name,
        email: comment_email,
        reply_to: props.comment_id,
      },
      (data, meta) => {
        console.log(data);
        context.notification("نظر شما با موفقیت ثبت شد .", "success");
        context.modal.show();
        set_comment_body("");
        set_comment_name("");
        set_comment_email("");
        if (props.modalClose) props.modalClose();
        set_requesting(false);
      },
      error => {
        context.notification("مشکلی در ارسال بوجود آمد.", "error");
        console.log(error);
        set_requesting(false);
      },
    );
  };

  return (
    <>
      <h2>{props.form_title}</h2>
      <hr />
      <Row className="mx-0">
        <Col md={6}>
          <Form.Group>
            <Form.Label>ایمیل:</Form.Label>
            <Form.Control
              id="email"
              type="email"
              value={comment_email}
              onChange={e => {
                set_comment_email(e.target.value);
              }}
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group>
            <Form.Label>نام:</Form.Label>
            <Form.Control
              id="fullname"
              type="text"
              value={comment_name}
              onChange={e => {
                set_comment_name(e.target.value);
              }}
            />
          </Form.Group>
        </Col>
      </Row>
      <div className="px-3">
        <Form.Group>
          <Form.Label>نظر</Form.Label>
          <FormControl
            id="body"
            as="textarea"
            value={comment_body}
            onChange={e => {
              set_comment_body(e.target.value);
            }}
          />
        </Form.Group>
      </div>
      <hr />
      <div className="d-flex justify-content-end">
        <Button
          variant="secondary"
          type="button"
          disabled={requesting}
          onClick={sendComment}>
          {requesting ? "..." : "ارسال"}
        </Button>
      </div>
      <Modal>{"نظر شما با موفقیت ثبت شد"}</Modal>
    </>
  );
};

export default CommentForm;
